module.exports = __webpack_public_path__ + "img/radio-pulau-pinang.b3be8691.jpg";